export default "__VITE_ASSET__D2clw8br__"